import { Stack } from '@mui/material';

import { api } from 'common';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSelectField } from '../../../ConfigFields/SelectField';

export function PatientFormFields() {
  return (
    <>
      <Stack direction="column" spacing={2}>
        <BlockValueTemplateField fieldName="config.ehrInformationId" label="EHR Information ID" />
        <BlockValueTemplateField label="MRN" fieldName="config.mrn" />
        <BlockValueTemplateField label="First Name" fieldName="config.firstName" />
        <BlockValueTemplateField label="Last Name" fieldName="config.lastName" />
        <BlockValueTemplateField
          label="Phone Number"
          fieldName="config.phoneNumber"
          helperText="Matches against any patient phone number"
        />
        <BlockValueTemplateField label="Date of Birth" fieldName="config.dateOfBirth" />
        <BlockSelectField
          label="Patient Match Strictness Level"
          fieldName="config.patientMatchStrictness"
          helperText="Indicate the level of strictness for patient matching if a patient is found by MRN"
          options={[
            {
              label: 'Must match all of the provided demographic fields',
              value: api.Patient.PatientMatchStrictness.Strict,
            },
            {
              label: 'Must match at least two of the provided demographic fields',
              value: api.Patient.PatientMatchStrictness.TwoOrMore,
            },
            {
              label: 'Must match at least three of the provided demographic fields',
              value: api.Patient.PatientMatchStrictness.ThreeOrMore,
            },
          ]}
        />
      </Stack>
    </>
  );
}
